import script from "./ContentActivityLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentActivityLog.vue?vue&type=script&lang=ts&setup=true"

import "./ContentActivityLog.vue?vue&type=style&index=0&id=6f6493e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6493e5"]])

export default __exports__